import { render, staticRenderFns } from "./OrderMedia.vue?vue&type=template&id=1dc7864d&scoped=true&"
import script from "./OrderMedia.vue?vue&type=script&lang=js&"
export * from "./OrderMedia.vue?vue&type=script&lang=js&"
import style0 from "./OrderMedia.vue?vue&type=style&index=0&id=1dc7864d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7864d",
  null
  
)

export default component.exports